<template>
  <div class="loading" :class="{'show': loading}">
    <div class="loading-box">
      <div class="line-spin-fade-loader">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'loading',
  props: ['loading'],
  created: function () {
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.loading
  position absolute
  display flex
  flex-direction column
  justify-content center
  align-items center
  width 100%
  height 100%
  z-index 1000
  .loading-box
    width 26px
    height 26px
    .line-spin-fade-loader
      position relative
      top -10px
      left -4px
      div
        position absolute
        width 2px
        height 6px
        background-color #3d3d3d
        border-radius 2px
        margin 2px
        animation-fill-mode both
        &:nth-child(1)
          top 9px
          left 0
          animation line-spin-fade-loader 1.2s -0.84s infinite ease-in-out
        &:nth-child(2)
          top 6.36492px
          left 6.36492px
          transform rotate(-45deg)
          animation line-spin-fade-loader 1.2s -0.72s infinite ease-in-out
        &:nth-child(3)
          top 0
          left 9px
          transform rotate(90deg)
          animation line-spin-fade-loader 1.2s -0.6s infinite ease-in-out
        &:nth-child(4)
          top -6.36492px
          left 6.36492px
          transform rotate(45deg)
          animation: line-spin-fade-loader 1.2s -0.48s infinite ease-in-out
        &:nth-child(5)
          top -9px
          left 0
          animation line-spin-fade-loader 1.2s -0.36s infinite ease-in-out
        &:nth-child(6)
          top -6.36492px
          left -6.36492px
          transform rotate(-45deg)
          animation line-spin-fade-loader 1.2s -0.24s infinite ease-in-out
        &:nth-child(7)
          top 0
          left -9px
          transform rotate(90deg)
          animation line-spin-fade-loader 1.2s -0.12s infinite ease-in-out
        &:nth-child(8)
          top 6.36492px
          left -6.36492px
          transform rotate(45deg)
          animation line-spin-fade-loader 1.2s 0s infinite ease-in-out

@keyframes line-spin-fade-loader
  50%
    opacity: 0.3
  100%
    opacity 1
</style>



// WEBPACK FOOTER //
// src/components/Loading.vue